import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    /* Task BalancePro */
    async getTaskBalansProResponses(taskId) {
      return await this.get(`tasks/id/${taskId}/balans-pro-responses`);
    },
    // Получение деталей интеграции с Баланс Про
    async getTaskWorkerDetails(taskWorkerId) {
      return await this.get(`integration/task_balans_pro/${taskWorkerId}`);
    },
    // Обновление статусов оплаты исполнителям 2
    async postTaskUpdatePay(data, organizationId) {
      const ids = data.task_ids.map(function (item) {
        return "&task_ids[]=" + item;
      });
      const taskIds = ids.join('').substring(1);

      return await this.put(`integration/task_balans_pro?organization_id=${organizationId}&${taskIds}`, data);
    },
    // Получение связи исполнителя с Баланс Про
    async getWorkerBalansProIntegration(data) {
      return await this.get(`integration/worker_integration/${data.id}`, {ignore404: true});
    },
    // Поиск исполнителя с Баланс Про по номеру телефона
    async getBalansProWorker(data) {
      return await this.get(`integration/worker/find?inn=${data.inn}&organization_id=${data.orgId}`);
    },
    // Создание связи исполнителя с Баланс Про
    async linkBalansProWorker(data) {
      return await this.post('integration/worker_integration', data);
    },
    // Удаление связи исполнителя с Баланс Про
    async unlinkBalansProWorker(data) {
      return await this.delete(`integration/worker_integration/${data.id}`, null);
    },

    /* Organization BalancePro & Avito */

    // Получение интеграций организации
    async getOrganizationIntegrations(organizationId) {
      return await this.get(`organization_integration/${organizationId}`, {ignore404: true});
    },
    async postOrganizationIntegrations(data) {
      return await this.post('organization_integration', data);
    },
    async putOrganizationIntegrations(data) {
      return await this.put(`organization_integration/organization`, data);
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/balansPro.js